import { isFlagValueOn } from './flag-value'

export function isKalamaTeaserEnabled(): boolean {
  return isFlagValueOn(import.meta.env.VITE_KALAMA_TEASER_ENABLED)
}

export function isKalamaBrandingEnabled(): boolean {
  return isFlagValueOn(import.meta.env.VITE_KALAMA_BRANDING_ENABLED)
}

/** The branding flag wins: the S-619 teasers never show once the brand has switched. */
export function isKalamaTeaserActive(): boolean {
  return isKalamaTeaserEnabled() && !isKalamaBrandingEnabled()
}
